<template>
  <div>
    <!-- 成绩查看 -->
    <component :is="currentComponent"></component>
  </div>
</template>

<script>
  import StudentShowAchievement from './StudentShowAchievement.vue'
  import AdminShowAchievement from './AdminShowAchievement.vue'
  export default {
    name: 'showAchievement',
    components: {
      StudentShowAchievement,
      AdminShowAchievement
    },
    data () {
      return {
        APIPath: this.$store.state.apiPath + '/api/Achievement',
        type: 1,
        currentComponent: ''
      }
    },
    created: function () {
      this.getUser()
      // let _this = this
      // // 重定向页面
      // this.xy.get(_this.APIPath + '/GeUserType', null).then(res => {
      //   _this.type = res.data
      //   if (_this.type === 1) {
      //     // 学生
      //     this.currentComponent = StudentShowAchievement
      //   } else if (_this.type === 2 || _this.type === 3 || _this.type === 4) {
      //     // 管理员
      //     this.currentComponent = AdminShowAchievement
      //   }
      // })
      // // if (_this.type === 1) {
      // //   // 学生
      // //   console.log(111)
      // //   this.currentComponent = StudentShowAchievement
      // // } else if (_this.type === 2 || _this.type === 4) {
      // //   // 管理员
      // //   this.currentComponent = AdminShowAchievement
      // // } else if (_this.type === 3) {
      // //   // 班主任
      // //   this.currentComponent = HeadmasterShowAchievement
      // // }
    },
    mounted: function () {

    },
    methods: {
      async getUser(){
        let res = await this.xyapi.get(this.APIPath + '/GeUserType', null)
        this.type = res.data
        if (this.type === 1) {
          // 学生
          this.currentComponent = StudentShowAchievement
        } else if (this.type === 2 || this.type === 3 || this.type === 4) {
          // 管理员
          this.currentComponent = AdminShowAchievement
        }

      }
    }
  }
</script>
